var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudyMaterials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6045_3807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3721 2.47192C30.0241 2.47192 32.1721 4.61992 32.1721 7.27192V33.5279H3.82812V2.47192H27.3721Z",
    stroke: "black",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.94 3.6001H18V6.5401H20.94V3.6001Z",
    fill: "#E71D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9888 6.54004H15.0488V9.48004H17.9888V6.54004Z",
    fill: "#E71D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.94 9.49219H18V12.4322H20.94V9.49219Z",
    fill: "#E71D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9888 12.4321H15.0488V15.3721H17.9888V12.4321Z",
    fill: "#E71D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.94 15.3721H18V18.3121H20.94V15.3721Z",
    fill: "#E71D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9525 18.3242H15.0605V21.2642H20.9525V18.3242Z",
    fill: "#E71D2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6045_3807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyMaterials);
export default __webpack_public_path__ + "static/media/study-materials.7775e354be2cad50cf086036138bc9fd.svg";
export { ForwardRef as ReactComponent };